import { Component, OnInit, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { MsalService } from '@azure/msal-angular';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  imports: [RouterOutlet],
})
export class AppComponent implements OnInit {
  title = 'Backoffice Seguro Personas';
  private readonly msalService = inject(MsalService);

  ngOnInit() {
    // Guarantees MSAL is initialized on every page load, regardless of which route
    // loads first. Routes without MsalGuard (e.g. /no-access) never trigger this
    // otherwise, and any MSAL API call before initialize() throws
    // "uninitialized_public_client_application".
    this.msalService.initialize().subscribe();
  }
}
